// extracted by mini-css-extract-plugin
module.exports = {"displayHeading":"DisplayHeading_displayHeading__mwFcX"};